import React, { useContext, useState, FC } from 'react';
import { ImageDataLike } from 'gatsby-plugin-image';
import { StaffProfileFeedFragment, Kfh_StaffType } from '../types/graphqlTypes';
import { Card } from './Card';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { Section, SectionBackgroundColour } from './Section';
import { UiStateContext } from '../context/UiStateContext';
import { StaffBlade } from './staff/StaffBlade';

interface StaffProfileFeedProps extends StaffProfileFeedFragment {
  width: 'narrow' | 'wide';
}

// JSX

export const StaffProfileFeed: FC<Omit<StaffProfileFeedProps, '__typename'>> = ({
  title,
  backgroundColour,
  action,
  division,
  width,
}) => {
  const [activeProfile, setActiveProfile] = useState<Kfh_StaffType>();
  const { setActiveBlade } = useContext(UiStateContext);

  if (!division || division?.divisionStaffs?.length === 0) {
    return null;
  }

  const divisionStaffs = division?.divisionStaffs.filter(d => !!d?.staff) || [];

  if(divisionStaffs.length === 0) {
    return null;
  }

  const background = backgroundColour ? backgroundColour.replace('1', '') : 'white';
  return (
    <Section contained background={background as SectionBackgroundColour} narrow={width === 'narrow'} overflowHidden>
      <CardCarouselWrapper heading={title} width={width}>
        {divisionStaffs.map((divisionStaff, index) => {

  
          const { fullName, position, mediaSet, email, directDialNumber } = divisionStaff?.staff || {};

          const profileImage = mediaSet?.media?.filter((mediaItem) => mediaItem.role === 'Profile')[0]?.media
            ?.localFile;

          return (
            <Card
              key={index}
              image={profileImage as unknown as ImageDataLike}
              heading={fullName}
              lead={position}
              actionLabel={action === 'Profile' ? 'View profile' : ''}
              onClick={() => {
                if (action === 'Profile') {
                  setActiveBlade('staff');
                  setActiveProfile(divisionStaff?.staff as unknown as Kfh_StaffType);
                }
              }}
              footerMeta={
                action !== 'Profile'
                  ? `<div>${email ? `<a href="mailto:${email}">${email}</a>` : ''}
              ${
                directDialNumber
                  ? `<br><a href="tel:${directDialNumber.replace(/\s/g, '')}">${directDialNumber}</a>`
                  : ''
              }</div>`
                  : ''
              }
              backgroundColor={backgroundColour === 'white' || !backgroundColour ? 'grey1' : 'white'}
            />
          );
        })}
      </CardCarouselWrapper>
      {action === 'Profile' && activeProfile ? <StaffBlade staff={activeProfile} /> : ''}
    </Section>
  );
};
